export default __webpack_public_path__ + "static/media/percent.512a1faf.svg";